import {
  CREDITOPTIONDETAIL_LOADING,
  GET_CREDITOPTIONDETAIL,
  GET_CREDITOPTIONDETAIL_SUCCESS,
  GET_CREDITOPTIONDETAIL_FAIL,
  ADD_CREDITOPTIONDETAIL_SUCCESS,
  ADD_CREDITOPTIONDETAIL_FAIL,
  DELETE_CREDITOPTIONDETAIL_SUCCESS,
  DELETE_CREDITOPTIONDETAIL_FAIL,
  UPDATE_CREDITOPTIONDETAIL_SUCCESS,
  UPDATE_CREDITOPTIONDETAIL_FAIL,
  CREDITOPTIONDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  creditOptionDetails: [],
  error: {},
};

const CreditOptionDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CREDITOPTIONDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CREDITOPTIONDETAIL:
          return {
            ...state,
            creditOptionDetails: action.payload.data,
            isCreditOptionDetailCreated: false,
            isCreditOptionDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CREDITOPTIONDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_CREDITOPTIONDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCreditOptionDetailCreated: false,
            isCreditOptionDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CREDITOPTIONDETAIL: {
      return {
        ...state,
        isCreditOptionDetailCreated: false,
        loading: true,
      };
    }

    case CREDITOPTIONDETAIL_LOADING: {
      return {
        ...state,
        isCreditOptionDetailCreated: false,
        loading: true,
      };
    }

    case ADD_CREDITOPTIONDETAIL_SUCCESS:
      return {
        ...state,
        isCreditOptionDetailCreated: true,
        loading: false,
        creditOptionDetails: [action.payload.data, ...state.creditOptionDetails],
      };

    case ADD_CREDITOPTIONDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CREDITOPTIONDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isCreditOptionDetailCreated: true,
        creditOptionDetails: state.creditOptionDetails.filter(
          creditOptionDetail => creditOptionDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CREDITOPTIONDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CREDITOPTIONDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isCreditOptionDetailCreated: true,
        creditOptionDetails: state.creditOptionDetails.map(creditOptionDetail =>
          creditOptionDetail.id.toString() === action.payload.data.id.toString() ? { ...creditOptionDetail, ...action.payload.data } : creditOptionDetail
        ),
      };

    case UPDATE_CREDITOPTIONDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREDITOPTIONDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CreditOptionDetail;